import { render } from "./Item.vue?vue&type=template&id=2801f70b&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=2801f70b&scoped=true&lang=css"

import exportComponent from "/builds/it60371727/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2801f70b"]])

export default __exports__